<template>
    <div>
        <md-dialog :md-fullscreen="true"
                   :md-active.sync="showDialog">
            <md-dialog-content>
                <md-empty-state
                        md-icon="logout"
                        md-label="You are now logged out">
                    <md-button to="/" class="md-primary md-raised">OK</md-button>
                </md-empty-state>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
    export default {
        name: "logout-alert",
        props: ['showDialog']
    }
</script>

<style scoped>

</style>